const Footer = () => {

  return (
    <footer className="py-1 bg-black">
      <div className="text-white mx-auto text-center">
        Deny Senesouma ©2026
      </div>
    </footer>
  );
};

export default Footer;
